<template>
  <div class="purchase-order-detail">
    <el-card>
      <div slot="header" class="purchase-header">
        <span>
          <a @click="$router.back()">{{ $t('purchase::purchase-list::order') }}</a>
          / {{ $t('purchase::purchase-list::detail') }}
        </span>
        <div
          class="purchase-status"
          :style="{
            color: statusToColor[purchaseDetail.purchaseStatus],
            borderColor: statusToColor[purchaseDetail.purchaseStatus]
          }"
        >
          {{ purchaseDetail.purchaseStatusName }}
        </div>
      </div>
      <el-row :gutter="10">
        <el-col :span="8" class="row-item">
          <span class="d-label" style="font-weight: bold">{{ $t('purchase::purchase-list::order_num') }}</span>
          <span class="d-value" style="font-weight: bold">{{ $dataCheck(purchaseDetail.purchaseNo) }}</span>
        </el-col>
        <el-col :span="8" class="row-item">
          <span class="d-label">{{ $t('purchase::purchase-list::creator') }}</span>
          <span class="d-value">{{ $dataCheck(purchaseDetail.createName) }}</span>
        </el-col>
        <el-col :span="8" class="row-item">
          <span class="d-label">{{ $t('purchase::purchase-list::re_auditor') }}</span>
          <span class="d-value">{{ $dataCheck(purchaseDetail.reviewerName) }}</span>
        </el-col>
        <el-col :span="8" class="row-item">
          <span class="d-label">{{ $t('purchase::purchase-list::supplier') }}</span>
          <span class="d-value">{{ $dataCheck(purchaseDetail.supplier) }}</span>
        </el-col>
        <el-col :span="8" class="row-item">
          <span class="d-label">{{ $t('purchase::purchase-list::create_time') }}</span>
          <span class="d-value">{{ $dataCheck(purchaseDetail.createTime) }}</span>
        </el-col>
        <el-col :span="8" class="row-item">
          <span class="d-label">{{ $t('purchase::purchase-list::re_audit_time') }}</span>
          <span class="d-value">{{ $dataCheck(purchaseDetail.reviewTime) }}</span>
        </el-col>
        <el-col :span="8" class="row-item">
          <span class="d-label">{{ $t('purchase::purchase-list::plan_arrival_date') }}</span>
          <span class="d-value">{{ $dataCheck(purchaseDetail.arrivalTime) }}</span>
        </el-col>
        <el-col :span="16" class="row-item">
          <span class="d-label">{{ $t('purchase::purchase-list::auditor') }}</span>
          <span class="d-value">{{ $dataCheck(purchaseDetail.auditorName) }}</span>
        </el-col>
        <el-col :span="8" class="row-item">
          <span class="d-label">{{ $t('purchase::purchase-list::purchse_total_amount') }}</span>
          <span class="d-value">{{ $dataCheck(purchaseDetail.totalPrice) }}</span>
        </el-col>
        <el-col :span="16" class="row-item">
          <span class="d-label">{{ $t('purchase::purchase-list::audit_time') }}</span>
          <span class="d-value">{{ $dataCheck(purchaseDetail.auditTime) }}</span>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="mt10">
      <z-table :columns="detailColumns" :data="purchaseDetail.detail" :pagination="false" v-loading="loading">
        <template v-slot:title="{ row }">
          <div class="sku-title">
            <el-image :src="row.img" style="width: 50px; height: 50px"></el-image>
            <div style="margin-left: 10px">
              <p class="one-line" style="width: 250px">{{ row.spuName }}</p>
              <p>{{ row.optionValueNames }}</p>
            </div>
          </div>
        </template>
        <template v-slot:singlePriceHeader>
          {{ $t('purchase::purchase-list::single_price') }}
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">
              {{ $t('purchase::purchase-list::price_equal') }}
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <template v-slot:quantity="{ row }">
          <p>{{ $t('purchase::purchase-list::purchase_amount') }}：{{ row.skuBuyQuantity }}</p>
          <p style="color: #F59A23">{{ $t('purchase::purchase-list::arrival_amount') }}：{{ row.skuArrivalQuantity }}</p>
        </template>
        <template v-slot:progress="{ row }">
          <el-progress :percentage="progress(row)" color="#70b603"></el-progress>
        </template>
      </z-table>
    </el-card>
  </div>
</template>

<script>
import { detailColumns, statusToColor } from '@/views/purchase/config'
import { getPurchaseDetail } from '@/server/purchase'
export default {
  name: 'purchase-list',
  data() {
    return {
      detailColumns,
      statusToColor,
      purchaseDetail: {
        detail: []
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    async getDetail() {
      this.loading = true
      const { data } = await getPurchaseDetail(this.$route.params.id)
      this.loading = false
      if (data.code === this.$code) {
        this.purchaseDetail = data.data
      }
    },
    progress(row) {
      const progress = (row.skuArrivalQuantity / row.skuBuyQuantity) * 100
      return row.skuBuyQuantity > 0 ? parseInt(progress) : 0
    }
  }
}
</script>

<style lang="scss" scoped>
.purchase-order-detail {
  .purchase-header {
    display: flex;
    justify-content: space-between;
    .purchase-status {
      width: 78px;
      height: 32px;
      border-width: 1px;
      border-style: solid;
      text-align: center;
      line-height: 32px;
      border-radius: 5px;
    }
  }
  .d-label {
    display: inline-block;
    width: 100px;
  }
  .row-item {
    margin: 10px 0;
  }
  .sku-title {
    display: flex;
    align-items: center;
  }
}
</style>
